import * as React from "react";

export function EmailIcon(props: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M29.3337 7.99967C29.3337 6.53301 28.1337 5.33301 26.667 5.33301H5.33366C3.86699 5.33301 2.66699 6.53301 2.66699 7.99967V23.9997C2.66699 25.4663 3.86699 26.6663 5.33366 26.6663H26.667C28.1337 26.6663 29.3337 25.4663 29.3337 23.9997V7.99967ZM26.667 7.99967L16.0003 14.6663L5.33366 7.99967H26.667ZM26.667 23.9997H5.33366V10.6663L16.0003 17.333L26.667 10.6663V23.9997Z" fill="currentColor"/>
    </svg>
  );
}
